import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconArrowRight = ({ color = 'currentColor', size = 'medium', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 32" size={size} {...props}>
        <StyledStrokedGroup color={color}>
            <StyledPath color="none" strokeWidth="2px" d="M1 16h30M17 30l14-14L17 2" />
        </StyledStrokedGroup>
    </StyledSvg>
);
